// extracted by mini-css-extract-plugin
module.exports = {"simple":"styles_simple__3p9EA","simple__header":"styles_simple__header__18xFB","simple__logo":"styles_simple__logo__2UBUT","simple__article":"styles_simple__article__3gbi2"};